import { getCatalog } from '../../services/emission';
import * as actionTypes from '../constants';
import { setLoading } from './quotation';

export const getCatalogQuestion = () => async (dispatch) => {
  dispatch(setLoading(true));
  getCatalog({ data: 'questions' })
    .then(({ data }) => {
      dispatch(setQuest(data.data));
    })
    .catch((e) => console.log(e))
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const getCatalogRules = () => async (dispatch) => {
  dispatch(setLoading(true));
  getCatalog({ data: 'rules' })
    .then(({ data }) => {
      dispatch(setRules(data.data));
    })
    .catch((e) => console.log(e))
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const getCatalogProvinces = () => async (dispatch) => {
  dispatch(setLoading(true));
  getCatalog({ data: 'provinceRestricted' })
    .then(({ data }) => {
      console.log('catalogo de provincias:', data);
      dispatch(setProvinces(data.data));
    })
    .catch((e) => console.log(e))
    .finally(() => {
      dispatch(setLoading(false));
    });
};

export const getCatalogVehicle = () => async (dispatch) => {
  dispatch(setLoading(true));
  getCatalog({ data: 'vehicleRestricted' })
    .then(({ data }) => {
      dispatch(setVehicles(data.data));
    })
    .catch((e) => console.log(e))
    .finally(() => {
      dispatch(setLoading(false));
    });
};

// export const setLoading = (data) => {
//   return {
//     type: actionTypes.SET_LOADING_EMISSION,
//     payload: data,
//   };
// };

export const setQuest = (data) => {
  return {
    type: actionTypes.GET_CATALOG_QUEST,
    payload: data,
  };
};

export const setRules = (data) => {
  return {
    type: actionTypes.GET_CATALOG_RULES,
    payload: data,
  };
};

export const setVehicles = (data) => {
  return {
    type: actionTypes.GET_CATALOG_VEHICLES,
    payload: data,
  };
};

export const setProvinces = (data) => {
  return {
    type: actionTypes.GET_CATALOG_PROVINCES,
    payload: data,
  };
};
